import {
	Component,
	Input,
	OnDestroy,
	Output,
	EventEmitter,
	OnInit,
	HostListener
} from '@angular/core';
import { KngLoaderState } from 'kinetic-angular';
import { Subscription } from 'rxjs';
import { LoggerService } from '../../services/logger/logger.service';
import { Icons } from '../../services/shared/shared-enums';
import { MainEntry, MainEntryState } from './definitions';
import { MainEntryService } from './main-entry.service';
import { Router } from '@angular/router';
import { AnalyticsService } from '../../services/analytics/analytics.service';

@Component({
	selector: 'tmhna-portal-main-entry',
	templateUrl: './template/main-entry.component.html',
	styleUrls: ['./template/main-entry.component.scss']
})
export class MainEntryComponent
implements OnDestroy, OnInit, MainEntry
{
	private readonly subscriptions: Subscription = new Subscription();
	public innerWidth: number = window.innerWidth ;

	@Input() set state(value: MainEntryState)
	{
		this.service.updateState(value);
	}
	get state(): MainEntryState
	{
		return this.service.state;
	}
	get isRaymond(): boolean
	{
		return this.service.isRaymond || false;
	}


	public loaderState: KngLoaderState = {
		imagePath: Icons.loaderOrange
	};
	@Output() stateChanged: EventEmitter<MainEntryState> =
		new EventEmitter<MainEntryState>();


	@HostListener('window:resize', ['$event'])
	onResize()
	{
		this.innerWidth = window.innerWidth;
	}

	constructor(private readonly service: MainEntryService, public loggerService: LoggerService, public router: Router, private readonly analyticsService: AnalyticsService) { }

	ngOnInit(): void
	{
		this.analyticsService.trackRegistrationByEvent({
    		event: 'pageView',
    		page: {
    			name: 'Landing page'
    		}
    	}, '');
		this.service.getLandingPageAemLabels();
		const stateChangeSubs: Subscription = this.service.stateChanged.subscribe(
			(next: MainEntryState) => this.stateChanged.emit(next)
		);
		this.subscriptions.add(stateChangeSubs);
	}

	ngOnDestroy(): void
	{
		this.destroySubscriptions();
	}

	private destroySubscriptions(): void
	{
		this.subscriptions.unsubscribe();
	}

	public loginRegisterEvent()
	{
		this.analyticsService.trackRegistrationByEvent({
    		event: 'Register /Login',
    		link: {
    			name: 'Register Button'
    		}
    	}, '');
		this.router.navigate(['auth']);
	}

	public navigateToShop()
	{
		this.analyticsService.trackRegistrationByEvent({
			event: 'Shop Now',
			link: {
				name: 'Shop Now'
			}
		}, '');
	}
}
